<template>
  <label class="icon-box" @click="handleClick">
    <auth-img class="icon-img" :src="img" alt="" />
    <div class="icon-label">快捷链接</div>
  </label>
  <a-modal
    width="875px"
    v-model:visible="visible"
    :bodyStyle="bodyStyle"
    cancelText="取消"
    :ok-button-props="{ disabled: loading }"
    okText="发送给患者"
    @ok="handleOk"
    @cancel="handleCancel"
    centered
  >
    <template #title>
      <div>
        发送快捷链接
        <span class="header-tip" style="font-size: 14px; color: #ff9412">
          （发送后患者可一键跳转对应页面）
        </span>
      </div>
    </template>
    <div class="quick-link-box">
      <div class="left-con">
        <div class="item">
          <div class="title">选择链接类型：</div>
          <div class="link-con">
            <a-space :size="[0, 12]">
              <div
                v-for="item in customMessageMap"
                :key="item.value"
                class="link-item"
                @click="selectLinkType(item)"
              >
                <a-radio :checked="selectedLinkType.value === item.value"></a-radio>
                <span>{{ item.eventName }}</span>
              </div>
            </a-space>
          </div>
        </div>
        <div class="item">
          <div class="title">填写内容：</div>
          <a-textarea
            v-model:value="contentText"
            placeholder="请填写发给患者的内容"
            :autoSize="{ minRows: 7, maxRows: 7 }"
            :maxlength="1000"
            showCount
          />
        </div>
      </div>
      <div class="right-con">
        <div class="preview-box">
          <div class="preview-header">
            <span class="preview-name">健管姓名</span>
            <span class="preview-tip">健管</span>
          </div>
          <div class="preview-con-box">
            <QuickLinkDialogue
              :content-text="contentText || '你填写的文字内容'"
              :btn-name="selectedLinkType.eventName || '链接类型'"
            />
          </div>
        </div>
        <img :src="userIcon" alt="" />
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import img from '@/assets/img/chat/quickLink.png'
import userIcon from '@/assets/img/chat/head_z.png'

import { reactive, ref, defineProps } from 'vue'
import { customMessageMap } from '@/views/WorkPlace/Container/chat/components/message/config'
import { message } from 'ant-design-vue'
import { QuickLinkDialogue } from '@/views/WorkPlace/Container/chat/components'
import { quickLinkSend } from '@/api/chat'
import store from '@/store'
const visible = ref(false)
const loading = ref(false)
const contentText = ref('')
const selectedLinkType = ref({
  value: '',
  eventName: '',
  type: ''
})

const props = defineProps({
  groupId: {
    type: String,
    default: '',
    required: true
  },
  workOrderGroupInfo: {
    type: Object,
    default: () => {},
    required: true
  }
})

const bodyStyle = reactive({
  padding: '0',
  height: '396px',
  backgroundColor: '#FAFAFA'
})

const handleClick = () => {
  visible.value = true
}

const handleOk = () => {
  if (!selectedLinkType.value.value) {
    message.warning('请选择选择链接类型')
    return
  }
  if (!contentText.value?.trim()) {
    message.warning('请填写发给患者的内容')
    return
  }
  const { doctorInfo = {}, patientInfo = {}, curDocAss = {} } = props.workOrderGroupInfo || {}

  // console.log('_++_store.getters.chatId', store.getters.chatId, curDocAss.userId)

  const params = {
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId,
    textContent: contentText.value,
    linkType: selectedLinkType.value.type,
    groupId: props.groupId,
    from: curDocAss.userId
  }
  quickLinkSend(params)
    .then(res => {
      handleCancel()
    })
    .catch(error => {})
}
const handleCancel = () => {
  visible.value = false
  contentText.value = ''
  selectedLinkType.value = {
    value: '',
    eventName: '',
    type: ''
  }
}

const selectLinkType = item => {
  if (selectedLinkType.value.value === item.value) {
    // 如果点击的是已选中的，则取消选中
    // selectedLinkType.value = {
    //   value: '',
    //   eventName: '',
    //   type: ''
    // }
  } else {
    // 否则选中该项
    selectedLinkType.value = item
    contentText.value = ''
  }
}
</script>

<style lang="scss" scoped>
@import '../../index.scss';
.icon-box {
  .icon-label.active {
    color: #1890ff;
  }
}
.quick-link-box {
  display: flex;
  height: 100%;

  .left-con {
    width: 530px;
    background: #ffffff;
    padding: 24px;
    overflow: auto;

    :deep(.ant-space) {
      flex-wrap: wrap;

      .ant-space-item {
        width: 25%;
      }
    }

    :deep(.ant-input) {
      word-break: break-all;
      border: none !important;
      box-shadow: none !important;
      border-radius: 4px !important;
    }
    :deep(.ant-input:focus) {
      border-color: none !important;
      box-shadow: none !important;
    }

    :deep(.ant-input-textarea) {
      border: 1px solid #d9d9d9 !important;
      border-radius: 4px !important;
    }
    :deep(.ant-input-textarea-show-count::after) {
      padding-bottom: 12px;
      padding-right: 12px;
      box-sizing: border-box;
      opacity: 0.6;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 10px;
      color: #999999;
    }
    .item {
      margin-bottom: 24px;
      .title {
        margin-bottom: 12px;
        font-size: 14px;
        color: #333333;
        font-weight: 500;
      }

      .link-con {
        display: flex;
        flex-wrap: wrap;

        .link-item {
          flex: 1;
          display: flex;
          cursor: pointer;

          span {
            font-size: 14px;
            color: #3b3b3b;
            user-select: none;
            flex: 1;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .right-con {
    flex: 1;
    display: flex;
    padding: 24px;
    .preview-box {
      flex: 1;
      padding-right: 10px;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .preview-header {
        display: flex;
        align-items: center;
        justify-content: end;
        text-align: right;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 14px;
        color: #666666;

        .preview-tip {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 20px;
          border-radius: 4px;
          background: #f9f0ff;
          font-weight: 400;
          font-size: 12px;
          color: #722ed1;
          margin-left: 4px;
        }
      }

      .preview-con-box {
        flex: 1;
        overflow: auto;
      }
    }

    img {
      width: 44px;
      height: 44px;
      border-radius: 4px;
    }
  }
}
</style>
